module.exports = __webpack_public_path__ + "components/affiliate/static/external-9cbc78a66e53040c6f48a2f6b01df672.svg";